import { atom } from 'nanostores'

export const lat = atom<number>(null)
export const long = atom<number>(null)
export const city = atom<string>(null)
export const state = atom<string>(null)
export const geoLoading = atom<boolean>(true)

type SharpSeatApiResponse = {
	location: {
		city: string
		country: 'US'
		flag: '🇺🇸'
		countryRegion: 'VA'
		region: 'iad1'
		latitude: string
		longitude: string
	}
	lat: string
	long: string
	city: string
}

export function setGeo(latitude: number, longitude: number) {
	lat.set(latitude)
	long.set(longitude)
}

export const refreshGeo = async () => {
	console.log('REFRESH GEO')
	geoLoading.set(true)
	try {
		if ('geolocation' in navigator) {
			navigator.geolocation.getCurrentPosition((position) => {
				lat.set(position.coords.latitude)
				long.set(position.coords.longitude)
				console.log(position)
			})
		}
	} catch (error) {
		console.error(error)
	} finally {
		geoLoading.set(false)
	}
}

export const refreshGeoVercel = async () => {
	console.log('REFRESH Vercel GEO')
	geoLoading.set(true)
	try {
		let ipjson = await fetch('/api/ip', {
			mode: 'cors',
		})
		let res = (await ipjson.json()) as SharpSeatApiResponse

		const { location } = res

		const newLat = res.lat || location.latitude
		const newLong = res.long || location.longitude

		if (newLat || newLong) {
			setGeo(Number(newLat), Number(newLong))
		}

		if (location?.city) {
			city.set(location.city)
		}
		if (location?.countryRegion) {
			state.set(location.countryRegion)
		}
	} catch (error) {
		console.error(error)
	} finally {
		geoLoading.set(false)
	}
}
